import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.structuralVariant.inFrame',
  title: {
    id: 'omicsExplorer.filters.structuralVariant.inFrame',
    defaultMessage: 'In Frame',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'inFrame',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.structuralVariant.inFrame.yes',
        searchValue: 'yes,Yes',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.inFrame.yes',
          defaultMessage: 'Yes',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.inFrame.no',
        searchValue: 'no,No',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.inFrame.no',
          defaultMessage: 'No',
        },
      },
      {
        id: 'omicsExplorer.filters.structuralVariant.inFrame.unknown',
        searchValue: 'unknown,Unknown',
        intlLabel: {
          id: 'omicsExplorer.filters.structuralVariant.inFrame.unknown',
          defaultMessage: 'Unknown',
        },
      },
    ],
  },
};
